const GA_ID = 'G-FJLQVBDLV6';

const gtag = (...args) => {
  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};

// Page view
export const trackPageView = (path, title) => {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
};

// Generic event
export const trackEvent = (eventName, params = {}) => {
  gtag('event', eventName, params);
};

// Auth events
export const trackLogin = (method = 'email') => {
  gtag('event', 'login', { method });
};

export const trackSignUp = (method = 'email') => {
  gtag('event', 'sign_up', { method });
};

// Onboarding events
export const trackOnboardingStep = (stepIndex, stepName) => {
  gtag('event', 'onboarding_step', {
    step_index: stepIndex,
    step_name: stepName,
  });
};

export const trackOnboardingComplete = (companyId, industry) => {
  gtag('event', 'onboarding_complete', {
    company_id: companyId,
    industry,
  });
};

// Billing / Checkout events
export const trackBeginCheckout = (packageId, amount, currency) => {
  gtag('event', 'begin_checkout', {
    currency: (currency || 'gbp').toUpperCase(),
    value: amount,
    items: [{ item_id: packageId }],
  });
};

export const trackPurchase = (transactionId, amount, currency) => {
  gtag('event', 'purchase', {
    transaction_id: transactionId,
    currency: (currency || 'gbp').toUpperCase(),
    value: amount,
  });
};

export const trackSubscriptionCancel = (subscriptionId) => {
  gtag('event', 'subscription_cancel', { subscription_id: subscriptionId });
};

export const trackSubscriptionReactivate = (subscriptionId) => {
  gtag('event', 'subscription_reactivate', { subscription_id: subscriptionId });
};

// Interaction events
export const trackButtonClick = (buttonName, context = '') => {
  gtag('event', 'button_click', { button_name: buttonName, context });
};

export const trackVoiceSelect = (voiceId, voiceName) => {
  gtag('event', 'voice_select', { voice_id: voiceId, voice_name: voiceName });
};

export const trackVoicePreview = (voiceId, voiceName) => {
  gtag('event', 'voice_preview', { voice_id: voiceId, voice_name: voiceName });
};

export const trackReportDownload = (reportType) => {
  gtag('event', 'report_download', { report_type: reportType });
};

export const trackInvoiceDownload = (invoiceId) => {
  gtag('event', 'invoice_download', { invoice_id: invoiceId });
};

export const trackSearch = (searchTerm, context) => {
  gtag('event', 'search', { search_term: searchTerm, context });
};

export const trackFormInteraction = (formName, action) => {
  gtag('event', 'form_interaction', { form_name: formName, action });
};

// Set user properties (call after login)
export const setUserProperties = (userId, role, companyId) => {
  gtag('set', 'user_properties', {
    user_role: role,
    company_id: companyId || 'none',
  });
  if (userId) {
    gtag('config', GA_ID, { user_id: userId });
  }
};
